<script>
const nav = {
  // general: {
  //   icon: 'tool',
  //   text: 'General',
  //   route: 'hyperion.setting.general'
  // },
  webhook: {
    icon: 'pull-request',
    text: 'Webhook',
    route: 'hyperion.setting.webhook',
  },
  // response: {
  //   icon: 'rollback',
  //   text: 'Responses',
  //   route: 'hyperion.setting.response'
  // }
}

export default {
  data: () => ({
    nav
  })
}
</script>
<template>
  <a-menu theme="light" mode="inline" :defaultSelectedKeys="[ getRoute() ]" style="height: 100%">
    <template v-for="(item, index) in nav">
      <a-menu-item :key="item.route">
        <a :href="routeUri(item.route)">
          <a-icon :type="item.icon" />
          <span>{{ item.text }}</span>
        </a>
      </a-menu-item>
    </template>
  </a-menu>
</template>

